var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.198f97db0bdcefb3b716f88ee0bec883.svg#q';
                    var viewUrl = 'sprites.198f97db0bdcefb3b716f88ee0bec883.svg#view-q';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 14 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };